<template>
  <div>
    <h3 class="header-title">Manage</h3>
    <CRow class="mt-3">
    <CCol sm="2">
      <CCard style="height: 100px" @click="GoToFindTutor()" class="pointer">
        <div class="text-center p-2">
          <br />
          <img
            style="max-height: 30px"
            src="../assets/img/listsubject.svg"
            class="pointer"
          />
          <br />
          <label class="pointer">Find Tutor</label>
        </div>
      </CCard>
    </CCol>
    <CCol sm="2">
      <CCard style="height: 100px" @click="GoToTutor()" class="pointer">
        <br />
        <div class="text-center p-2">
          <img
            style="max-height: 30px"
            src="../assets/img/listpackage.svg"
            class="pointer"
          />
          <br />
          <label class="pointer">Tutor</label>
        </div>
      </CCard>
    </CCol>
    
  </CRow>
  </div>
</template>
  
  
<script>
import Vue from "vue";
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgtips.png";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import { CChartLine } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

import "@fullcalendar/core/vdom"; // solves problem with Vite]
import AutoLogout from './AutoLogout.vue';

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import { getColor, deepObjectsMerge } from "@coreui/utils/src";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
  },

  data() {
    return {
      
    };
  },
  
  computed: {
    
  },

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            // this.GetStudent();
            // this.GetTeacher();
            // this.GetSchedule();
            // this.GetTotalPaidUnpaid();
            // this.GetScheduleCurrentWeek();
            // this.GetAskKiddo();
            // this.GetScheduleWeek();
            // this.GetCreatedAttendance();
            // this.GetAnnouncement();
            console.log(":testing" + this.user.id);
            // this.GetCheckTc(this.user.tuitioncenter);

            // if(this.user.invoicepaidts == null)
            // {
            //   this.GoToLogin();

            // }
          }
        });
    },

    GoToFindTutor() {
      this.$router.push("FindTutorExam");
    },

    GoToTutor() {
      this.$router.push("TutorList");
    },
    
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

.c-app {
  font-family: montserrat, Sans-serif;
}
.pointer {
  cursor: pointer;
}
</style>  
  
  <!-- <template>
    <div>
      <CCol sm="12" lg="12">
        <CRow>
          <CCol sm="4">
            <CCard>
              <h5 class="text-center mt-3">Manage Region</h5>
              <hr />
              <label class="text-center">To add, update and delete region</label>
              <br />
              <div class="text-center mb-3">
              <CButton color="success" size="sm" :href="'#/Region'">View Detail</CButton>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4">
            <CCard>
              <h5 class="text-center mt-3">Manage Zone</h5>
              <hr />
              <label class="text-center">To add, update and delete zone</label>
               <br />
              <div class="text-center mb-3">
              <CButton color="success" size="sm" :href="'#/Zone'">View Detail</CButton>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4">
            <CCard>
              <h5 class="text-center mt-3">Manage Site</h5>
              <hr />
              <label class="text-center">To add, update and delete site</label>
               <br />
              <div class="text-center mb-3">
              <CButton color="success" size="sm" :href="'#/SiteName'">View Detail</CButton>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4">
            <CCard>
              <h5 class="text-center mt-3">Manage WorkType</h5>
              <hr />
              <label class="text-center">To add, update and delete worktype</label>
               <br />
              <div class="text-center mb-3">
              <CButton color="success" size="sm" :href="'#/WorkType'">View Detail</CButton>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4">
            <CCard>
              <h5 class="text-center mt-3">Manage Element</h5>
              <hr />
              <label class="text-center">To add, update and delete element</label>
               <br />
              <div class="text-center mb-3">
              <CButton color="success" size="sm" :href="'#/Element'">View Detail</CButton>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4">
            <CCard>
              <h5 class="text-center mt-3">Manage Sub Element</h5>
              <hr />
              <label class="text-center">To add, update and delete sub element</label>
               <br />
              <div class="text-center mb-3">
              <CButton color="success" size="sm" :href="'#/SubElement'">View Detail</CButton>
              </div>
            </CCard>
          </CCol>
           <CCol sm="4">
            <CCard>
              <h5 class="text-center mt-3">Manage Team</h5>
              <hr />
              <label class="text-center">To add, update and delete team</label>
               <br />
              <div class="text-center mb-3">
              <CButton color="success" size="sm" :href="'#/Team'">View Detail</CButton>
              </div>
            </CCard>
          </CCol>
            <CCol sm="4">
            <CCard>
              <h5 class="text-center mt-3">Manage User</h5>
              <hr />
              <label class="text-center">To add, update and delete user</label>
               <br />
              <div class="text-center mb-3">
              <CButton color="success" size="sm" :href="'#/User'">View Detail</CButton>
              </div>
            </CCard>
          </CCol>
            <CCol sm="4">
            <CCard>
              <h5 class="text-center mt-3">Manage Work Order</h5>
              <hr />
              <label class="text-center">To update work order</label>
               <br />
              <div class="text-center mb-3">
              <CButton color="success" size="sm" :href="'#/WorkOrder'">View Detail</CButton>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4">
            <CCard>
              <h5 class="text-center mt-3">Manage Project</h5>
              <hr />
              <label class="text-center">To add, update and delete project</label>
               <br />
              <div class="text-center mb-3">
              <CButton color="success" size="sm" :href="'#/ProjectType'">View Detail</CButton>
              </div>
            </CCard>
          </CCol>
          <CCol sm="4">
            <CCard>
              <h5 class="text-center mt-3">Customer</h5>
              <hr />
              <label class="text-center">To add, update and delete customer</label>
               <br />
              <div class="text-center mb-3">
              <CButton color="success" size="sm" :href="'#/Customer'">View Detail</CButton>
              </div>
            </CCard>
          </CCol>
        </CRow>
      </CCol>
    </div>
  </template> -->